import { LInputField } from "./LInputField";

export const LTableSearch = ({ ...props }: TableSearchProps): JSX.Element => {
    return (
        <div className="columns py-3 px-5">
            <div className={`column no-wrap mr-5 is-${props.resultCountContainerSize ?? 3}`}>
                <h1 className="title">
                    {props.numRecords} {props.resultsLabel ? props.resultsLabel : "Results"}
                    {props.showInactive && (
                        <span className="search-sub-text ml-2">({props.inactiveCount} inactive)</span>
                    )}
                </h1>
            </div>
            <div className="column is-one-quarter">
                <LInputField
                    inputName="searchTable"
                    isRounded={true}
                    isSearch={true}
                    placeholder={props.label ?? "Search Results"}
                    onChange={props.handleSearch}
                />
            </div>
        </div>
    );
};

interface TableSearchProps {
    numRecords: number;
    resultsLabel?: string;
    /** HTML input `onChange` attribute */
    handleSearch?: React.ChangeEventHandler;
    label?: string;
    showInactive?: boolean;
    inactiveCount?: number;
    resultCountContainerSize?: "1" | "2" | "3" | "4" | "5" | "6" | "7" | undefined;
}
